import { render, staticRenderFns } from "./shareModal.vue?vue&type=template&id=2c3b62cb&lang=html&"
import script from "./shareModal.vue?vue&type=script&lang=js&"
export * from "./shareModal.vue?vue&type=script&lang=js&"
import style0 from "./shareModal.vue?vue&type=style&index=0&id=2c3b62cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports